import React from "react";
import { whySelectra } from "../data/siteData";
import useScrollReveal, { revealUp } from "../hooks/useScrollReveal";
import "./WhySelectra.css";

export default function WhySelectra() {
  const sectionRef = useScrollReveal(({ gsap, el }) => {
    gsap.from(el.querySelectorAll(".why__item"), {
      ...revealUp(null, el.querySelector(".why__grid")),
      stagger: 0.08,
    });
  }, []);

  return (
    <section className="why section" ref={sectionRef}>
      <div className="container">
        <span className="eyebrow">Why Selectra</span>
        <h2 className="why__title">WHAT SETS US APART</h2>

        <div className="why__grid">
          {whySelectra.map((item) => (
            <div className="why__item" key={item.number}>
              <span className="why__item-number accent-text">{item.number}</span>
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
